export default "__VITE_ASSET__DRyUE3Eo__"